import { render, staticRenderFns } from "./NotaryProductTabs.vue?vue&type=template&id=6080ac8c&scoped=true&"
import script from "./NotaryProductTabs.vue?vue&type=script&lang=ts&"
export * from "./NotaryProductTabs.vue?vue&type=script&lang=ts&"
import style0 from "./NotaryProductTabs.vue?vue&type=style&index=0&id=6080ac8c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080ac8c",
  null
  
)

export default component.exports